import config from '@/config'

const backendURLGenerator = (pathName: string) => `${config.restUrl}/v1${pathName}`

export const api = {
  backoffice: {
    rejectPreview: (claimId: string) =>
      backendURLGenerator(`/backoffice/e-claim/${claimId}/reject-preview`),
    reject: (claimFormId: string) =>
      backendURLGenerator(`/backoffice/e-claim/${claimFormId}/reject`),
    rejectDocument: (claimFormId: string) =>
      backendURLGenerator(`/backoffice/e-claim/${claimFormId}/reject-document`),
    cancelCeClaim: (claimFormId: string) =>
      backendURLGenerator(`/backoffice/e-claim/${claimFormId}/cancel-ce`),
    requestDocument: backendURLGenerator(`/backoffice/e-claim/request-document`),
    sendRequestDocumentNotification: backendURLGenerator(
      `/backoffice/e-claim/request-document/send-notification`,
    ),
    downloadDocument: (claimId: string) =>
      backendURLGenerator(`/backoffice/e-claim/${claimId}/claim-documents/download`),
    listHealthClaimUserApprove: (search: string, page: number, limit: number) =>
      backendURLGenerator(
        `/backoffice/backofficer-user-approval-condition/health?${search}page=${page}&limit=${limit}`,
      ),
    listHealthClaimApproveLevel: backendURLGenerator(`/backoffice/approval-condition/health`),
    createHealthClaimAutoAssignment: backendURLGenerator(
      `/backoffice/pool/health-claim-auto-assignment/members`,
    ),
    deleteUserApprovalCondition: (approvalConditionId: string) =>
      backendURLGenerator(`/backoffice/backofficer-user-approval-condition/${approvalConditionId}`),

    deleteHealthClaimApproveLevel: (id: string) =>
      backendURLGenerator(`/backoffice/approval-condition/${id}`),
    createUserApprovalCondition: backendURLGenerator(
      `/backoffice/backofficer-user-approval-condition`,
    ),
    createBackofficeApproverCondition: backendURLGenerator(`/backoffice/approval-condition/health`),
    updateBackofficeApproverCondition: (id: string | number) =>
      backendURLGenerator(`/backoffice/approval-condition/health/${id}/edit`),
  },
}

export default api
